import type { FloatLabelType } from '@angular/material/form-field';
import {
  MUNILY_FILTER_FIELD_DEFAULT_FLOAT_LABEL,
  MUNILY_FILTER_FIELD_DEFAULT_SIZE,
  MunilyFilterFieldSize,
} from '../filter-fields/filter-field.types';
import { MunilyTextFieldWidthLayout } from '../text-field/text-field.types';

/** Tipo de `<input>` soportado por el filter text (toolbar). */
export type MunilyFilterTextFieldInputType = 'text' | 'password' | 'number' | 'email' | 'tel';

/** Valores por defecto del contrato público (alineado al DS / playground). */
export const MUNILY_FILTER_TEXT_FIELD_DEFAULTS: {
  size: MunilyFilterFieldSize;
  widthLayout: MunilyTextFieldWidthLayout;
  type: MunilyFilterTextFieldInputType;
  floatLabel: FloatLabelType;
  autocomplete: string;
  hasCharacterCounter: boolean;
} = {
  size: MUNILY_FILTER_FIELD_DEFAULT_SIZE,
  widthLayout: 'ds',
  type: 'text',
  floatLabel: MUNILY_FILTER_FIELD_DEFAULT_FLOAT_LABEL,
  autocomplete: 'off',
  hasCharacterCounter: false,
};
